// extracted by mini-css-extract-plugin
export default {"container":"MaxWidth_container__pMbeS","fullHeight":"MaxWidth_fullHeight__znY6V"};